import { render } from "./EngineBox.vue?vue&type=template&id=27ef49c2&scoped=true&ts=true"
import script from "./EngineBox.vue?vue&type=script&lang=ts"
export * from "./EngineBox.vue?vue&type=script&lang=ts"

import "./EngineBox.vue?vue&type=style&index=0&id=27ef49c2&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ef49c2"]])

export default __exports__